module.exports = __webpack_public_path__ + "img/waiqin.5e7fb820.png";